import { ENTITY, ROUTES } from '@constants'

import type { RouteStrategy, RouteStrategyParams } from './routeStrategy'

const routeMap: Record<string, string> = {
  [ENTITY.DROP_DOWN_ENTITY]: ROUTES.CONFIG_DROP_DOWN_ENTITY_EDIT,
  [ENTITY.VIEW]: ROUTES.CONFIG_VIEWS_EDIT,
  [ENTITY.LIST_CONTROL]: ROUTES.CONFIG_LIST_CONTROLS_EDIT,
}

export class EntityRoute implements RouteStrategy {
  public getRedirectPath(params: RouteStrategyParams): string | undefined {
    const { entityType, code } = params

    if (!code || !entityType) {
      console.warn('Code and entityType are required to redirect to config')

      return
    }

    return routeMap[entityType] ? `${routeMap[entityType]}/${code}` : undefined
  }
}
